import Countdown from './Countdown';
import Statistic from './Statistic';
Statistic.Countdown = Countdown;
export default Statistic;